// web端初始化
import StorageUtils from './core/storageUtils'

export const initWeb = function({ Vue, Store }, { brandCode, language }) {
  return new Promise((resolve) => {
    if (brandCode) {
      StorageUtils.sessionStorage.set('brandCode', brandCode)
      Store.commit('setBrandCode', brandCode)
    }
    if (language) {
      StorageUtils.sessionStorage.set('language', language)
      Store.commit('setLanguage', language)
    }
    resolve()
  }) 
}
